import getMetaElements from "shared/components/MetaTags/getMetaElements"
import getMetaTagsString from "shared/components/MetaTags/getMetaTagsString"
import { getSmallestImage } from "./helpers/utils"

/**
 * функция отвечает за формирование шаблона в блоке head разметки
 */
export const getHeadTemplate = ({ props, activeRoute, objProps }: any) => {
    const { projectRu } = props
    const { req } = objProps
    const hostOrig = req.get('host')
    if (!projectRu) return
    const projectTitle = projectRu.title
    const ogUrl = `https://${hostOrig}${req.url}`
    const smallestImage = getSmallestImage(projectRu.titleImages);
    const imageUrl = smallestImage ? `https://files.mediiia.ru/${smallestImage.url}` : null;

    const elements = getMetaElements({ title: projectTitle, imageUrl })

    const metaTags = getMetaTagsString(elements)

    return `
        <title>${projectTitle}</title>
        ${metaTags}
    `
}import getMetaElements from "shared/components/MetaTags/getMetaElements"
import getMetaTagsString from "shared/components/MetaTags/getMetaTagsString"
import { getSmallestImage } from "./helpers/utils"

/**
 * функция отвечает за формирование шаблона в блоке head разметки
 */
export const getHeadTemplate = ({ props, activeRoute, objProps }: any) => {
    const { projectRu } = props
    const { req } = objProps
    const hostOrig = req.get('host')
    if (!projectRu) return
    const projectTitle = projectRu.title
    const ogUrl = `https://${hostOrig}${req.url}`
    const smallestImage = getSmallestImage(projectRu.titleImages);
    const imageUrl = smallestImage ? `https://files.mediiia.ru/${smallestImage.url}` : null;

    const elements = getMetaElements({ title: projectTitle, imageUrl })

    const metaTags = getMetaTagsString(elements)

    return `
        <title>${projectTitle}</title>
        ${metaTags}
    `
}